export default "/images/vendor/flag-icon-css/flags/4x3/ua.svg?0551427e6aedc96255968bec9ea25716";